import React, { useState } from "react";
import VideoLesson from "./VideoLessons";
import StudentLiveClass from "./StudentLiveClass";
import Forum from "./Forum";
import UpcomingLessons from "./UpcomingLessons";

const MyLessons = ({userInfo}) => {
  const [activeTab, setActiveTab] = useState("liveClasses");

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      {/* Navigation Buttons */}
      <nav className="bg-gray-100 text-white py-4 px-6 rounded-lg shadow-lg mb-6">
        <div className="flex justify-center space-x-4">
          <button
            className={`px-6 py-2 rounded ${
              activeTab === "liveClasses"
                ? "bg-blue-800"
                : "bg-blue-500 hover:bg-blue-700"
            }`}
            onClick={() => setActiveTab("liveClasses")}
          >
            Live Classes
          </button>
          <button
            className={`px-6 py-2 rounded ${
              activeTab === "videoLessons"
                ? "bg-blue-800"
                : "bg-blue-500 hover:bg-blue-700"
            }`}
            onClick={() => setActiveTab("videoLessons")}
          >
            Video Lessons
          </button>
          <button
            className={`px-6 py-2 rounded ${
              activeTab === "UpcomingClasses"
                ? "bg-blue-800"
                : "bg-blue-500 hover:bg-blue-700"
            }`}
            onClick={() => setActiveTab("UpcomingClasses")}
          >
            Upcoming Classes
          </button>
          
        </div>
      </nav>

      {/* Content */}
      <div className="bg-white p-6 rounded-lg shadow-lg">
        {activeTab === "liveClasses" && (
          <div>
            
            <p className="text-gray-600">
              Here you can join live classes and interact with instructors in
              real-time.
            </p>
            <StudentLiveClass userInfo={userInfo}/>
          </div>
        )}
        {activeTab === "videoLessons" && (
          <div>
            
            <p className="text-gray-600">
              Browse through recorded video lessons to learn at your own pace.
            </p>
            <VideoLesson/>
          </div>
        )}
        {activeTab === "UpcomingClasses" && (
          <div>
            
            
            <UpcomingLessons userInfo={userInfo} />
          </div>
        )}
       
      </div>
    </div>
  );
};

export default MyLessons;
